import styled from '@emotion/styled';
import { Tag } from '@naf-simba/elements-tag';
import { spacing } from '@naf/theme';

export const Badge = styled(Tag)`
  position: absolute;
  top: -12px;
  left: ${spacing.space16};
`;
